import type { Model } from '@patsnap/tahiti-core';
import type { FeatureInitResponse } from '../types';

export const PermissionV2Model = Symbol.for('PermissionV2Model');

export interface PermissionV2Model extends Model<FeatureInitResponse> {}
